var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFireFeaturesDivisionalBoundary = function SvgFireFeaturesDivisionalBoundary(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#004ABC",
    d: "M5 2.466c1.63 2.964 2.63 6.47 2.63 10.09 0 3.462-.93 6.47-2.63 9.91h3.212c1.98-3.19 3.33-6.04 3.33-9.932 0-3.779-1.304-7.24-3.306-10.068zm14 0h-3.236c-2.002 2.828-3.305 6.29-3.305 10.068 0 3.891 1.35 6.742 3.329 9.932H19c-1.7-3.44-2.63-6.448-2.63-9.91 0-3.62 1-7.126 2.63-10.09"
  })));
};
export default SvgFireFeaturesDivisionalBoundary;